import { createSlice } from "@reduxjs/toolkit";
import { nearByCitiesAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const nearByCitiesSlice = createSlice({
  name: "nearByCities",
  initialState: data,
  reducers: {
    nearByCitiesSlice(state) {
      state.isLoading = false;
    },
    nearByCitiesSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    nearByCitiesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    nearByCitiesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const nearByCitiesHandler = (zipcode:any="") => async (dispatch: any) => {
  try {
    dispatch(nearByCitiesAction.nearByCitiesSlice());
    const response: any = await nearByCitiesAPI(zipcode);
    if(response){
      typeof localStorage !=="undefined"&&localStorage.removeItem('zipcodeAdd');
    }
    dispatch(nearByCitiesAction.nearByCitiesSliceSuccess(response));
  } catch (e: any) {
    dispatch(nearByCitiesAction.nearByCitiesSliceFailure(e?.response?.data?.message));
    dispatch(nearByCitiesAction.nearByCitiesSliceReset());
  }
};
export default nearByCitiesSlice.reducer;
export const nearByCitiesAction = nearByCitiesSlice.actions;
